import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Avatar, Grid, IconButton, Typography } from '@mui/material'
import { Draggable } from 'react-beautiful-dnd'
import { DndBurgerIcon } from 'src/assets/icons'

import useStyles from './styles'
import { IStepDtoWithId } from 'src/types'
import { TableRelationIcon } from '../table-relation-icon'
import { IAction } from '.'
import { AssociationsItemActions } from './associations-item-actions.component'

interface IAssociationsListItemProps {
  icon: string
  text: string
  id: string
  index: number
  withDnd: boolean
  subText?: string
  route: string | null
  item?: IStepDtoWithId
  actions?: IAction[]
  actionsTitle?: ReactNode
  disabled?: boolean
  aiGenerated?: boolean
  // isImpactsPageShow: boolean
  // isHomePageShow: boolean
}

const AssociationsListItem = ({
  route,
  icon,
  subText,
  id,
  index,
  text,
  withDnd,
  item,
  actions = [],
  actionsTitle,
  disabled,
  aiGenerated = false,
}: IAssociationsListItemProps) => {
  const classes = useStyles({ disableClickable: !route, aiGenerated })

  return (
    <>
      <Draggable key={id} index={index} draggableId={id}>
        {(provided) => (
          <div
            className={classes.selectionWrapper}
            {...provided.draggableProps}
            ref={provided.innerRef}
          >
            <Link to={route || '#'} className={classes.linkWrapper}>
              <Grid className={classes.selectionItem}>
                <Avatar alt={text} src={icon} className={`${classes.image}`} />
                <Grid>
                  <Typography className={`${classes.selectionText} ${classes.selectionTextDark}`}>
                    <strong>{text}</strong>
                  </Typography>
                  {subText && (
                    <Typography
                      className={`${classes.selectionSubtext} ${classes.selectionTextDark}`}
                    >
                      {subText}
                    </Typography>
                  )}
                </Grid>
                <Grid style={{ flexGrow: '1' }} />
                <Grid>
                  {item &&
                    item.impacts.map((impact) => {
                      return (
                        <TableRelationIcon
                          title={impact.name}
                          subtitle={'#' + impact.code}
                          key={impact.id}
                          icon={impact.image_small || impact.image}
                          iconAlt={impact.name}
                        />
                      )
                    })}
                </Grid>
              </Grid>
              {withDnd && (
                <IconButton
                  disabled={disabled}
                  {...provided.dragHandleProps}
                  className={classes.selectionItemDragIconButton}
                >
                  <DndBurgerIcon className={classes.selectionItemDragIcon} />
                </IconButton>
              )}
            </Link>
            {!disabled && actions.length > 0 && (
              <AssociationsItemActions id={id} actions={actions} actionsTitle={actionsTitle} />
            )}
          </div>
        )}
      </Draggable>
    </>
  )
}

export { AssociationsListItem }
